<template>
    <div class="skeleton-container">
        <ul v-show="mediaType == 'list'" class="list">
            <li v-for="(item,index) in list" :key="index">
                <div class="img"></div>
                <div class="content">
                    <p></p>
                    <div>
                        <span></span>
                        <span></span>
                    </div>
                    <p></p>
                </div>
            </li>
        </ul>
        <ul v-show="mediaType == 'media'" class="media" ref="list">
            <li v-for="(item,index) in list1" :key="index" :style="'height:'+itemHeight+'px'" :class="{list: true}">
                <div class="cover"></div>
                <div class="detail">
                    <div>
                        <p></p>
                        <p style="width: 80%"></p>
                    </div>
                    <div>
                        <p></p>
                        <p></p>
                    </div>
                </div>
            </li>
            <li class="fillItem" :style="{height: 0, width: `${fillWidth}px`}"></li>
        </ul>
    </div>
</template>

<script>
export default {
    props: {
        mediaType: {
            type: String,
            default: 'list'
        }
    },
    data() {
        return {
            list: [
                1,2,3,4,5,6,7,8,9,0
            ],
            list1: [
                1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1
            ],
            fillWidth: 0,
            itemHeight: 0
        }
    },
    methods: {
        calcFillWidth() {
            // console.log(999)
            // 计算填充元素宽度
            const list = this.$refs.list;
            if (!list || !list.getBoundingClientRect()) return;
            const listWidth = list.getBoundingClientRect().width;
            let fillWidth = 0;
            const itemWidth = 255; // item dom宽度
            const itemGap = 12; //item 边距
            const listGap = 0; // list左右边距
            const countsPerPage = this.list1.length || 20; //每页的item数量
            const containerWidth = listWidth - listGap; //容器实际宽度（dom宽度 - 左右padding）
            const countsPerRow = parseInt(containerWidth / (itemWidth + itemGap)); //每行item数量
            const countsLastLine = countsPerPage % countsPerRow || countsPerRow; //最后一行的item数量
            const itemRatio = 284.5 / 255;
            const itemWidthNow = (listWidth - listGap) / countsPerRow - itemGap;
            const itemHeightNow = itemWidthNow * itemRatio;

            fillWidth =
                countsPerRow === countsLastLine
                ? 0
                : (countsPerRow - countsLastLine) * (itemWidthNow + itemGap);

            this.fillWidth = fillWidth;
            this.itemHeight = (((listWidth/countsPerRow)-14)*9/16)+135;
            // this.itemHeight = itemHeightNow;
            // console.log('list', itemWidthNow, itemHeightNow, countsPerRow, fillWidth)
        },
        addCalcEvent() {
            // 监听list dom宽度变化
            window.addEventListener("resize", () => {
                this.calcFillWidth();
            });
        }
    },
    mounted() {
        this.addCalcEvent();
        this.calcFillWidth();
    }    
}
</script>
<style src="@assets/css/global.less" lang="less" scoped></style>
<style lang="less" scoped>
    .skeleton-container {
        width: 100%;

        ul.list {
            display: flex;
            flex-direction: column;
            width: 100%;

            li {
                display: flex;
                flex-direction: row;
                align-items: center;
                width: 100%;
                min-height: 300px;
                padding: 28px 30px 27px;
                border-bottom: 1px solid #f0f0f0;
                box-sizing: border-box;

                .img {
                    width: 240px;
                    height: 135px;
                    overflow: hidden;
                    border-radius: 4px;
                    background: linear-gradient(
90deg
,hsla(0,0%,74.5%,.2) 25%,hsla(0,0%,50.6%,.24) 37%,hsla(0,0%,74.5%,.2) 63%);
                    background-size: 400% 100%;
                    animation: linearMove 1.4s ease infinite;
                }

                .content {
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    flex: 1;
                    height: 135px;
                    margin-left: 30px;

                    p {
                        width: 100%;
                        height: 20px;
                        border-radius: 4px;
                        background: linear-gradient(
    90deg
    ,hsla(0,0%,74.5%,.2) 25%,hsla(0,0%,50.6%,.24) 37%,hsla(0,0%,74.5%,.2) 63%);
                        background-size: 400% 100%;
                        animation: linearMove 1.4s ease infinite;
                        margin-bottom: 18px;

                        &:nth-last-of-type(1) {
                            width: 100%;
                            height: 20px;
                            border-radius: 4px;
                            margin-bottom: 0px;
                        }
                    }

                    div {
                        width: 100%;
                        flex: 1;

                        span {
                            display: block;
                            width: 100%;
                            height: 20px;
                            border-radius: 4px;
                            background: linear-gradient(
        90deg
        ,hsla(0,0%,74.5%,.2) 25%,hsla(0,0%,50.6%,.24) 37%,hsla(0,0%,74.5%,.2) 63%);
                            background-size: 400% 100%;
                            animation: linearMove 1.4s ease infinite;
                            margin-bottom: 7px;

                            &:nth-last-of-type(1) {
                                width: 40%;
                                margin-bottom: 0;
                            }
                        }
                    }
                }
            }
        }

        ul.media {
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            justify-content: center;
            width: 100%;

            li {
                list-style: none;
            }

            li.list {
                display: flex;
                flex-direction: column;
                min-width: 255px;
                flex: 1;
                height: 284.5px;
                min-height: 284.5px;
                border-radius: 4px;
                margin: 0 6px 40px;
                box-sizing: border-box;

                .cover {
                    display: flex;
                    width: 100%;
                    flex: 1;
                    border-radius: 4px;
                    overflow: hidden;
                    background: linear-gradient(
        90deg
        ,hsla(0,0%,74.5%,.2) 25%,hsla(0,0%,50.6%,.24) 37%,hsla(0,0%,74.5%,.2) 63%);
                            background-size: 400% 100%;
                            animation: linearMove 1.4s ease infinite;
                }

                .detail {
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    width: 100%;
                    height: 135px;
                    padding: 12px 0;
                    box-sizing: border-box;

                    div {
                        display: flex;
                        flex-direction: column;

                        p {
                            width: 100%;
                            height: 20px;
                            border-radius: 4px;
                    overflow: hidden;
                    background: linear-gradient(
        90deg
        ,hsla(0,0%,74.5%,.2) 25%,hsla(0,0%,50.6%,.24) 37%,hsla(0,0%,74.5%,.2) 63%);
                            background-size: 400% 100%;
                            animation: linearMove 1.4s ease infinite;
                            margin-bottom: 5px;

                            &:nth-last-of-type(1) {
                                width: 40%;
                                margin-bottom: 0;
                            }
                        }
                    }
                }
            }
        }

        @keyframes linearMove  {
            0% {
                background-position: 100% 50%
            }
            100% {
                background-position: 0 50%
            }
        }
    }
</style>